export default __webpack_public_path__ + "static/media/social-youtube-icon.60d2ae68.svg";